import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { ChecklistProfileSurvey } from '../../../class/checklist-profile-survey';
import { ChecklistProfileSurveyService } from '../../../service/checklist-profile-survey/checklist-profile-survey.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { ProfileSurvey } from '../../../class/profile-survey';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-checklist-profile-survey',
  templateUrl: './new-checklist-profile-survey.component.html',
  styleUrls: ['./new-checklist-profile-survey.component.scss']
})
export class NewChecklistProfileSurveyComponent implements OnInit {
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: ChecklistProfileSurvey;
    @Input() profileSurveyId: number;

    messages: Message[] = [];

    public promiseForm: Promise<any>;
    public form: FormGroup;

    public list_doc_profile_survey_id: AbstractControl ;
    public required: AbstractControl ;
    public es: any;

    public modViewDialog: boolean;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public checklistProfileSurveyService: ChecklistProfileSurveyService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {
        this.modViewDialog = false;

        this.save_exit = false;

        this.es = calendarES();
        
        this.form = fb.group({
            'list_doc_profile_survey_id': ['', Validators.compose([Validators.required])],
            'required': ['', Validators.compose([Validators.required])],
        });

        this.list_doc_profile_survey_id = this.form.controls['list_doc_profile_survey_id'];
        this.required = this.form.controls['required'];
    }

    ngOnInit() {
        if (this.edit) {
            this.list_doc_profile_survey_id.setValue(this.edit.list_doc_profile_survey_id);
            this.required.setValue(this.edit.required);
        } else {
            // this.activated.setValue(true);
            this.required.setValue(false);
        }
    }

    public cancelChecklistProfileSurvey () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newChecklistProfileSurvey(values);
    }

    public newChecklistProfileSurvey(values) {
        let profileSurveyId;
        // if (this.profileSurvey) {
            if (this.profileSurveyId) {
                profileSurveyId = this.profileSurveyId;
            }
        // }

        let listDocProfileSurveyId;
        if (values.list_doc_profile_survey_id) {
            listDocProfileSurveyId = parseInt(values.list_doc_profile_survey_id)
        }

        const param = {
            'profile_survey_id': profileSurveyId,
            'list_doc_profile_survey_id': listDocProfileSurveyId,
            'required': values.required,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.checklistProfileSurveyService.updateChecklistProfileSurvey(this.edit.id, param)
                :
                this.checklistProfileSurveyService.newChecklistProfileSurvey(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/checklist-profile-surveis/new-checklist-profile-survey/new-checklist-profile-survey.component.ts